/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../src/jobiqo/config/jobs');
const mergeDeepRight = require('ramda/src/mergeDeepRight');
const fixtures = require('./fixtures');

module.exports = mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    GEO_INFO: {
      radius: {
        defaultValue: 25,
      },
      types: ['(regions)'],
      fixtures,
    },
    DISABLE_EDIT_EXTERNAL_JOBS: false,
    ANALYTICS: {
      SOURCE_ENABLED: true,
    },
    JOB_APPLICATION_GDPR_ENABLED: true,
    AI: {
      JOB_DESCRIPTION: {
        enabled: true,
      },
    },
    JOB_POSTING_WIZARD_SKIP_BUNDLES_ALL_INCLUDED: true,
  },
});
